import React from 'react';
import ReactDOM from 'react-dom';
class DoMainAppInfo extends React.Component {


  constructor(props) {
    super(props);
    this.parent = props.parent; 
    this.param = props.param;
    this.state={};
  }


  componentDidMount () {
    $("#doMainAppInfoModel .modal").children(':first').draggable({ cursor: "move", containment: "parent" });
  }


  render () {
    var version = this.param.version;
    var clientVersion = this.param.clientVersion;
    var frameworkVersion = this.param.frameworkVersion;
    return (
      <div className="modal " style={{ display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
        <div className=" ui-draggable" style={{ alignSelf: "center", display: 'flex', flexFlow: 'column', background: "#ffffff", border: '1px solid #9B9B9B', boxShadow: '0 0 41px 5px rgba(0,0,0,0.25)', borderRadius: '2px',width: '380px', height: '260px' }}>
          <div className="modal-header" style={{ position:"relative" ,background:'white',border: 'none'}}>
            <div className="modal-close" onClick={this.closeAttachmentHandler.bind(this)}></div>
            <h5 className="modal-title" style={{display:'none'}}> 信息</h5>
          </div>
          <div style={{height:'100%'}} >
            <div style={{display:'flex',flexDirection:'row',flexGrow:100,height:'100%',width:'100%'}}>
              <div style={{overflow:'auto',width:'100%'}}>
                <div style={{height:'80px',width: '100%',display: 'flex',justifyContent: 'center',alignItems: 'center',marginBottom:"10px"}}><img style={{height:'80px'}} src='./html/Example/images/info2.png'></img></div>
                <div style={{height:'20px',width: '100%',display: 'flex',justifyContent: 'center',alignItems: 'center',marginBottom:"10px",color: 'rgba(51, 51, 51, 1)',fontWeight: '800'}}><span>版本信息</span></div>
                <div style={{height:'30px',width: '90%',display: 'flex',justifyContent: 'center',alignItems: 'center',border: '1px solid rgba(198, 198, 198, 1)',marginLeft: '5%',marginBottom: '5px',fontWeight: '400',color: 'rgba(51, 51, 51, 1)'}}>版本：{version}</div>
                <div style={{height:'30px',width: '90%',display: 'flex',justifyContent: 'center',alignItems: 'center',border: '1px solid rgba(198, 198, 198, 1)',marginLeft: '5%',marginBottom: '5px',fontWeight: '400',color: 'white',background: 'rgba(58, 118, 225, 0.8)'}}>数字域客户端版本：{clientVersion}</div>
                <div style={{height:'30px',width: '90%',display: 'flex',justifyContent: 'center',alignItems: 'center',border: '1px solid rgba(198, 198, 198, 1)',marginLeft: '5%',marginBottom: '5px',fontWeight: '400',color: 'rgba(51, 51, 51, 1)'}}>数字域服务端版本：{frameworkVersion}</div>
             </div>     
            </div>  
          </div>
        </div> 
      </div>
    );
  }
  closeAttachmentHandler () {
    //关掉要卸载
    let $reactComponentContainer = $("#doMainAppInfoModel .modal");
    ReactDOM.unmountComponentAtNode($reactComponentContainer[0]);
    $reactComponentContainer.remove();
  }
}

DoMainAppInfo.defaultProps = {
  

};

export default DoMainAppInfo;



// WEBPACK FOOTER //
// ./src/components/doMainAppInfo/DoMainAppInfo.js